import api from 'api/apiInstance';

export function documentPackMarkAsSeenApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
